import { render, staticRenderFns } from "./numberList.vue?vue&type=template&id=5203afa4&scoped=true"
import script from "./numberList.vue?vue&type=script&lang=js"
export * from "./numberList.vue?vue&type=script&lang=js"
import style0 from "./numberList.vue?vue&type=style&index=0&id=5203afa4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203afa4",
  null
  
)

export default component.exports